function initCategories() {
  const categoriesSliders = document.querySelectorAll('.categories__slider');

  if (categoriesSliders.length) {
    categoriesSliders.forEach(slider => {
      const swiper = new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: 20,

        navigation: {
          nextEl: slider.querySelector('.swiper-navigation__btn--next'),
          prevEl: slider.querySelector('.swiper-navigation__btn--prev'),
        },

        breakpoints: {
          0: {
            slidesPerView: 1.4,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 4,
          }
        },
      });
    });
  }
}

export { initCategories };
